import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../../providers/root-store-provider';
import { routes } from '../../../../config/routes';
import { IconDashboard } from '../../../../components/app/icons/dashboard';
import { IconTrades } from '../../../../components/app/icons/trades';
import { IconInvestment } from '../../../../components/app/icons/investment';
import { IconProfits } from '../../../../components/app/icons/profits';
import { IconDividends } from '../../../../components/app/icons/dividends';
import { IconReport } from '../../../../components/app/icons/report';
import { IconLogout } from '../../../../components/app/icons/logout';
import { IconUser } from '../../../../components/app/icons/user';
import { IconSettings } from '../../../../components/app/icons/settings';
import { IconImpersonate } from '../../../../components/app/icons/impersonate';
import { Menu } from '../../../../components/app/menu/menu';
import { MenuItem } from '../../../../components/app/menu/item/item';
import { Divider } from '../../../../components/app/divider/divider';
import { IconLeaderboard } from '../../../../components/app/icons/leaderboard';

export const NavigationMobile: React.FC = observer(() => {
    const { themeStore, authStore } = useRootStore();
    const router = useRouter();
    const { t } = useTranslation();

    const user = authStore.userProfile;
    const fullName = user?.fullName?.toString();

    const pages = [
        {
            icon: <IconDashboard />,
            name: t('layout.navigation.performance'),
            url: routes.app.index,
            isActive: router.pathname === '/app',
        },
        {
            icon: <IconTrades />,
            name: t('layout.navigation.assets'),
            url: routes.app.assets.stocks,
            isActive: router.pathname.includes('/assets'),
        },
        {
            icon: <IconInvestment />,
            name: t('layout.navigation.investment'),
            url: routes.app.invested,
            isActive: router.pathname.includes('/invested'),
        },
        {
            icon: <IconProfits />,
            name: t('layout.navigation.profits'),
            url: routes.app.profits,
            isActive: router.pathname.includes('/profits'),
        },
        {
            icon: <IconDividends />,
            name: t('layout.navigation.dividends'),
            url: routes.app.dividends,
            isActive: router.pathname.includes('/dividends'),
        },
        {
            icon: <IconReport />,
            name: t('layout.navigation.taxReport'),
            url: routes.app.taxReport,
            isActive: router.pathname.includes('/tax-report'),
        },
        {
            icon: <IconLeaderboard />,
            name: t('layout.navigation.leaderboard'),
            url: routes.app.leaderboard,
            isActive: router.pathname.includes('/leaderboard'),
        },
    ];

    return (
        <div
            className={`${
                themeStore.mobileNavigationDisplay ? 'block' : 'hidden'
            } overflow-auto border-t border-border bg-surface pb-medium`}
            style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                maxHeight: 'calc(100vh - 6.2rem)',
                boxShadow: 'inset 0px -1px 0px rgba(153, 153, 153, 0.16)',
            }}
        >
            <Menu layout={themeStore.layout}>
                {pages.map((item, index) => (
                    <MenuItem
                        key={index}
                        name={item.name}
                        url={item.url}
                        icon={item.icon}
                        isActive={item.isActive}
                        onClick={() => {
                            themeStore.toggleMobileNavigationDisplay();
                        }}
                    />
                ))}
            </Menu>

            <Divider gap="vsmall" />
            <Menu layout={themeStore.layout}>
                <MenuItem
                    name={fullName as string}
                    url={routes.app.profile}
                    icon={<IconUser />}
                    onClick={() => {
                        themeStore.toggleMobileNavigationDisplay();
                    }}
                />
                {user?.role === 'admin' ? (
                    <>
                        <MenuItem
                            url={routes.app.admin.analytics}
                            name={t('layout.navigation.administration')}
                            icon={<IconSettings />}
                            onClick={() => {
                                themeStore.toggleMobileNavigationDisplay();
                            }}
                        />
                        <MenuItem
                            onClick={() => {
                                authStore.impersonationDialogStore.setImpersonateActive();
                                themeStore.toggleMobileNavigationDisplay();
                            }}
                            name={t('dialogs.common.impersonation')}
                            icon={<IconImpersonate />}
                        />
                    </>
                ) : (
                    <></>
                )}
                <MenuItem
                    name={t('layout.profile.logOut')}
                    onClick={async () => {
                        await router.push(routes.web.indexLogout);
                    }}
                    icon={<IconLogout />}
                />
            </Menu>
        </div>
    );
});
